import * as React from "react";
import {MassiveActionProcessState, MassiveActionsContext} from "../MassiveActionsProvider";
import {VeboxOverlay} from "../../../components/overlay/VeboxOverlay";
import {ValidatedEquipmentInfoModal} from "../components/ValidatedEquipmentInfoModal";
import {MassiveActions, prepareInfoModalItems, prepareMassiveAction} from "../MassiveActionsTypesAndFunctions";
import {MassiveOnSubmitModal} from "../components/MassiveOnSubmitModal";
import {ProcessPage, ProcessStageOrder} from "../../Processes";
import {MassiveActionsProcessHeader} from "../components/UtilsComponents";
import {VeboxForm} from "../../../components/form/VeboxForm";
import {CodesValidation} from "../components/CodesValidation";
import {CodesCheckAndApprove} from "../components/CodesCheckAndApprove";
import {AppTranslations} from "../../../components/Utils/translations/AppTranslations";
import {DefaultErrorBoundaryFallback} from "../../../ErrorBoundary/DefaultErrorBoundaryFallback";

declare var AppTranslations: AppTranslations;

export const HeartBeat: React.FC = () => {
    const translations = AppTranslations.massiveActions.equipmentHeartBeat;

    const {
        validateCodes,
        validatedEquipmentsInfo,
        executeMassiveAction,
        availableMassivePatchesInfo
    } = React.useContext(MassiveActionsContext);


    const texts = [translations.insertEquipmentCodeListTitle, translations.checkAndConfirmTitle];
    const [values, setValues] = React.useState(undefined);
    const [massiveActionProcessState, setMassiveActionProcessState] = React.useState(
        MassiveActionProcessState.INITIAL);

    const closeModal = () => overlayController.clear()
    const overlayController = VeboxOverlay.useTarget(
        <ValidatedEquipmentInfoModal
            onClose={closeModal}
            title={translations.modalInfoTitle}
            statusElements={prepareInfoModalItems({
                title: translations.validatedEquipmentNotFoundTitle,
                description: translations.validatedEquipmentFoundDescription
            }, {
                title: translations.validatedEquipmentNotFoundTitle,
                description: translations.validatedEquipmentNotFoundDescription
            })}
        />
    );

    const executeAction = (validatedEquipmentGuids: string[]) => {
        setMassiveActionProcessState(MassiveActionProcessState.PENDING);
        executeMassiveAction(
            prepareMassiveAction(validatedEquipmentGuids,
                availableMassivePatchesInfo.availableMassivePatches,
                {valueInfo: {massiveAction: MassiveActions.EQUIPMENT_HEART_BEAT}}))
            .then(() => {
                overlayController.show(
                    <MassiveOnSubmitModal
                        title={translations.checkAndConfirmSuccessTitle}
                        descriptions={[translations.checkAndConfirmSuccessDescription]}
                        onClose={closeModal}
                        success={true}
                    />
                )
                setMassiveActionProcessState(MassiveActionProcessState.INITIAL);
            })
            .catch(manageErrors);
    }

    const manageErrors = (error: { errorType: string, message: string }) => {
        let descriptions: React.ReactNode[] = []
        switch (error.errorType) {
            case 'UNABLE_TO_DELETE_FILE_ON_SFTP':
            case 'UNABLE_TO_UPLOAD_FILE_ON_SFTP':
                descriptions.push(<DefaultErrorBoundaryFallback
                    errorMessage={AppTranslations.errorMessages.unableToPerformTheOperation}
                    style={{backgroundColor: "white"}}
                />)
                break;
            default:
                descriptions.push(<span>{translations.checkAndConfirmErrorDescription}</span>)
                break;
        }
        overlayController.show(
            <MassiveOnSubmitModal
                title={translations.checkAndConfirmErrorTitle}
                descriptions={descriptions}
                onClose={closeModal}
            />)
        setMassiveActionProcessState(MassiveActionProcessState.FAILURE);
    }

    return (
        <ProcessPage total={1} className={"flx-col"}>
            <MassiveActionsProcessHeader
                processHeaderTitle={translations.equipmentHeartBeatTitle}
                processIndicatorsTitles={texts}
            />
            <VeboxOverlay.Target {...overlayController.targetProps} className={"process-stages flx-row"}>
                <VeboxForm onChange={setValues} values={values}>
                    <CodesValidation
                        validationFunction={validateCodes}
                        stepNumber={1}
                        stageOrder={ProcessStageOrder.FIRST}
                        title={translations.insertEquipmentCodeListTitle}
                        cardTitle={translations.codeValidationCardTitle}
                        errorMessage={translations.codeValidationErrorTitle}
                        errorDescription={translations.codeValidationErrorDescription}
                        massiveActionProcessState={massiveActionProcessState}
                    />
                    <CodesCheckAndApprove
                        overlayController={overlayController}
                        submitFunction={executeAction}
                        stepNumber={2}
                        stageOrder={ProcessStageOrder.LAST}
                        title={translations.checkAndConfirmTitle}
                        validatedEquipmentsInfo={validatedEquipmentsInfo}
                        massiveActionProcessState={massiveActionProcessState}
                    />
                </VeboxForm>
            </VeboxOverlay.Target>
        </ProcessPage>
    )
}